import { render, staticRenderFns } from "./CreateWCAGAuditModal.vue?vue&type=template&id=7a27a04b"
import script from "./CreateWCAGAuditModal.vue?vue&type=script&lang=js"
export * from "./CreateWCAGAuditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports